import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { AuthConfigType, KeyValues3, LocalService, StatusWithId } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';
import { AuthConfigUi } from 'src/app/utils/authConfig';

@Injectable({
  providedIn: 'root'
})
export class AuthConfigService {
  private controllerName = service_controllers_methods.authConfig.controller;
  private methods = service_controllers_methods.authConfig.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public getAuthConfig(businessId: string, authType: AuthConfigType): Observable<AuthConfigUi> {
    const body = {
      sel: this.localService.getSelected(),
      dt: {
        v1: businessId,
        v2: authType.toString()
      } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetAuthConfig, body);
  }

  public saveAuthConfig(businessId: string, authType: AuthConfigType, dataJson: AuthConfigUi): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dataJson: dataJson,
      dt: {
        v1: businessId,
        v2: authType.toString()
      } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveAuthConfig, body);
  }
}
